import { Box, Text } from '@frontend/components';

const NoResults = (props) => (
  <Box
    bg="page.background"
    display="flex"
    justifyContent="center"
    padding={3}
    width="100%"
    {...props}
  >
    <Text color="feature.placeholder" fontWeight="heavy">
      No Results Found
    </Text>
  </Box>
);

export default NoResults;
